module.exports = __webpack_public_path__ + "static/media/terms-and-conditions-nl.cd3d129e.pdf";